export default {
  methods: {
    formatBalance(balance, prefix = '', suffix = '') {
      const balanceStr = balance.toString();
      const endsWithDot = balanceStr.endsWith('.');

      const parts = balanceStr.split('.');
      const integerPart = parts[0];
      const decimalPart = parts[1] ? '.' + parts[1] : (endsWithDot ? '.' : '');

      const formattedInteger = integerPart
        .split('')
        .reverse()
        .join('')
        .replace(/(\d{3})(?=\d)/g, '$1 ')
        .split('')
        .reverse()
        .join('');

      return prefix + formattedInteger + decimalPart + suffix;
    },
  },
};
